import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import ClassCommentListService from "../../../../services/screens/admin/homework/ClassCommentListService";
import { ActionTypes } from "../../../actionTypes/screens/admin/homework/ClassCommentListActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import Constants from "../../../../config/Constants";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.homework.classcommentlist;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: searchVO => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, searchVO });

            ClassCommentListService.loadScreenView(
                searchVO,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, searchVO) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        searchVO
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

};

//
// Initial State
//
const INITIAL_STATE = {
    commentList: null,
    pageCount: 0,
    totalCount: 0,
    searchVO: {
        pageIndex: 1,
        pageSize: Constants.DefaultPageSize,
        searchType: 0
    }
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, searchVO }) => {
    return {
        ...state,
        commentList: data.pagedComment.commentList,
        pageCount: data.pagedComment.pageCount,
        totalCount: data.pagedComment.totalCount,
        searchVO
    };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
